<template>
  <vx-card card-background="#3b3a3d" title="El proceso de onboarding se encuentra en proceso." title-color="white">
    <p class="text-white">
      El inversionista ha iniciado el proceso con Mati, y éste se encuentra en proceso de revisión, o bien, la cuenta STP
      está en proceso de ser generada.
    </p>
  </vx-card>
</template>

<script>
export default {
  name: "ComplianceRunning"
}
</script>
